export function forceInt(value) {
    const int = parseInt(value);
    return isNaN(int) ? undefined : int;
}


// WEBPACK FOOTER //
// ./src/utils/forceInt.js